import React from "react";
import { Heart, Star } from "lucide-react";
// REMOVED BROKEN IMPORT: import decisionHighlight from "../assets/decision-highlight.png";

const imageIds = [
  "1afdbc6cfe4689ceed86931eedd5333d1c9c8cba",
  "d8e1d7d52538cc519c1354412c3a783584f2115a",
  "26dc8454a37d9ccb6ea03ff25c7b3ba81a7b82b5",
  "c2b0bfd213a002ebdeb16ad542f8cdbbf40b5d72",
  "f9df68593fa1f286d96663b75a43d09d93d0ecd2",
  "7085f7508aac67ceaf5f7b14af59ee44bd6c0de4",
];

export const HeroSection = () => (
  <section className="mx-auto px-4 sm:px-8 lg:px-[133px] pt-12 lg:pt-[100px] pb-8">
    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div className="space-y-6">
        <h1 className="font-unbounded text-4xl sm:text-5xl lg:text-[58px] font-bold leading-tight lg:leading-[64px]">
          <span className="text-black">Your Path from High School to College </span>
          <span className="text-brand-orange">Mapped Out</span>
        </h1>
        <p className="font-satoshi text-xl text-[#5A5959] max-w-xl">
          SnapGrad brings together trusted school data, real community feedback, and actionable insight so you can confidently plan the next step in your academic journey and find the right home in the right neighborhood.
        </p>
      </div>

      <div className="grid grid-cols-6 gap-0 h-[453px]">
        {imageIds.map((id, index) => (
          <div key={id} className="col-span-1 grid grid-rows-[352px_101px] gap-0">
            <div className="bg-[#F50] overflow-hidden">
              <img
                src={`https://api.builder.io/api/v1/image/assets/TEMP/${id}?width=${index === 0 ? 1056 : index === 5 ? 470 : 832}`}
                alt="Students celebrating academic milestones"
                className="w-full h-full object-cover"
              />
            </div>
            <div
              className={[
                "bg-[#E8804C]",
                "bg-[#FDBE9E]",
                "bg-[#8C7461]",
                "bg-[#65534B]",
                "bg-[#F99E4E]",
                "bg-[#0A0A0A]",
              ][index]}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const CompareSection = () => (
  <section className="mx-auto px-4 sm:px-8 lg:px-[133px] py-16 lg:py-20">
    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div className="space-y-6 lg:space-y-10 max-w-xl">
        <div className="space-y-6">
          <h2 className="font-unbounded text-4xl lg:text-[48px] font-medium leading-tight lg:leading-[52px]">
            Compare and choose
          </h2>
          <p className="font-satoshi text-[20px] lg:text-[22px] text-[#3E3A37] leading-8">
            SnapGrad is your personalized guide to the college journey, helping students seamlessly transition from high school to higher education.
          </p>
        </div>
        <a
          href="#search"
          className="inline-flex items-center gap-2 font-unbounded text-[17px] font-semibold text-black underline decoration-2 underline-offset-4 hover:text-brand-orange transition-colors"
        >
          Start my list
          <span aria-hidden="true">&rarr;</span>
        </a>
      </div>

      <div className="relative flex justify-center lg:justify-end pt-6 lg:pt-0">
        <div className="absolute inset-x-10 bottom-0 h-24 bg-[#D7CEC7]/60 blur-[90px] rounded-full pointer-events-none" />

        <div className="relative w-full max-w-[520px] pb-16">
          <div className="absolute -top-10 -left-20 hidden lg:block w-[150px] h-[150px] rounded-full overflow-hidden border-[8px] border-white shadow-[0px_20px_40px_rgba(15,10,5,0.18)] z-10">
            <img
              src="https://api.builder.io/api/v1/image/assets/TEMP/f3aa0ab6f817315c5609ba7df0715e006616336c?width=398"
              alt="Student celebrating admission"
              className="w-full h-full object-cover"
            />
          </div>

          <LandingSchoolCard
            className="shadow-[0px_35px_70px_rgba(36,24,14,0.16)] max-w-[430px]"
            name="Noble Charter High School"
            rating="2/10"
            readiness="6"
            address="700 South State, Chicago, IL, 60605"
            stars={4.2}
            reviews={21}
            type="Public"
            level="High School"
          />

          <div className="absolute w-[90%] right-[-10px] -bottom-28">
            <div className="absolute -right-4 -top-12 hidden lg:block w-[120px] h-[120px] rounded-full overflow-hidden border-[8px] border-white shadow-[0px_18px_36px_rgba(15,10,5,0.2)] z-20">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/63f8c42ae385d1a85da989c8d9fff450a9b7147e?width=510"
                alt="Historic school building"
                className="w-full h-full object-cover"
              />
            </div>
            <CompactSchoolCard />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export const HomeSearchSection = () => (
  <section className="mx-auto px-4 sm:px-8 lg:px-[133px] py-16 lg:py-20">
    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div className="space-y-6 lg:space-y-8 max-w-xl">
        <div className="space-y-4">
          <h2 className="font-unbounded text-4xl lg:text-[48px] font-medium leading-tight lg:leading-[52px]">
            Search nearby homes
          </h2>
          <p className="font-satoshi text-[20px] lg:text-[22px] text-[#3E3A37] leading-8">
            Build a list of your top schools, line them up side by side, and quickly
            spot the neighborhood that’s right for you.
          </p>
        </div>
        <a
          href="#search"
          className="inline-flex items-center gap-2 font-unbounded text-[17px] font-semibold text-black underline decoration-2 underline-offset-4 hover:text-brand-orange transition-colors"
        >
          Start my list
          <span aria-hidden="true">&rarr;</span>
        </a>
      </div>

      <div className="relative flex justify-center lg:justify-end">
        <div className="w-full max-w-[420px] rounded-[40px] overflow-hidden shadow-[0px_40px_120px_rgba(0,0,0,0.25)] border border-black/10 bg-black text-white">
          <div className="relative h-[220px]">
            <img
              src="https://images.unsplash.com/photo-1565182999561-18d7dc61c393?auto=format&fit=crop&w=900&q=80"
              alt="Modern home exterior"
              className="w-full h-full object-cover"
            />
            <span className="absolute top-4 left-4 px-4 py-1.5 rounded-full bg-[#8FF05A] text-black font-unbounded text-[14px]">
              Open for Tour
            </span>
          </div>

          <div className="p-6 space-y-6">
            <div className="space-y-2">
              <p className="font-unbounded text-[36px]">$ 600,000</p>
              <p className="text-[16px] text-white/80">
                8035 225th Hwy N Chatsworth, Georgia (GA), 30705
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 text-center text-[15px]">
              <div className="space-y-1">
                <p className="font-semibold">3 Bed</p>
                <p className="text-white/60 text-sm">Spacious</p>
              </div>
              <div className="space-y-1">
                <p className="font-semibold">2 Bath</p>
                <p className="text-white/60 text-sm">Updated</p>
              </div>
              <div className="space-y-1">
                <p className="font-semibold">1.51 sft</p>
                <p className="text-white/60 text-sm">Lot size</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export const ShareStorySection = () => (
  <section className="mx-auto px-4 sm:px-8 lg:px-[133px] py-16 lg:py-24">
    <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-center">
      <div className="relative flex justify-center">
        <div className="relative w-full max-w-[460px] rounded-[40px] overflow-hidden shadow-[0px_50px_120px_rgba(16,19,32,0.35)]">
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/96a8dd084be99739a1052d5501a02902ca687752?width=1242"
            alt="Student getting ready to share a review"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute -top-10 -left-4 sm:left-0 w-[210px] sm:w-[230px] rounded-[30px] bg-white shadow-[0px_18px_60px_rgba(19,16,12,0.12)] border border-[#F0EDEA] p-4 space-y-3">
          <div className="space-y-1">
            <p className="font-unbounded text-[17px] font-semibold text-[#5B5753]">Leave a review</p>
            <p className="font-satoshi text-[18px] font-medium text-black leading-6">Please review this school:</p>
          </div>
          <div className="flex items-center gap-1">
            {[...Array(4)].map((_, i) => (
              <Star key={i} className="w-5 h-5 text-[#F4AA3C] fill-[#F4AA3C]" />
            ))}
            <Star className="w-5 h-5 text-[#C5C1BD]" />
          </div>
          <p className="font-satoshi text-[16px] text-black">Do you have any thoughts to share?</p>
          <div className="rounded-[14px] border border-[#E8E4DF] bg-[#F8F5F2] px-3.5 py-2.5 shadow-[0px_8px_20px_rgba(18,14,10,0.04)]">
            <p className="font-satoshi text-[15px] text-[#6A6661] leading-5">
              We love the teachers at this school!
              <br />
              Highly recommend!
            </p>
          </div>
        </div>

        <div className="absolute -bottom-10 left-10 flex items-end gap-4">
          <div className="bg-white rounded-[28px] px-6 py-4 shadow-[0px_20px_55px_rgba(22,15,8,0.18)] rotate-[-6deg]">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-12 w-12 rounded-full bg-[#16A570] text-white font-unbounded text-lg items-center justify-center">
                !
              </span>
              <span className="font-unbounded text-[16px] text-[#1C1B1A]">Share it loud</span>
            </div>
          </div>
          <div className="flex gap-2">
            {[...Array(4)].map((_, i) => (
              <Heart key={i} className="w-10 h-10 text-[#FF6AA9] fill-[#FF6AA9]" />
            ))}
          </div>
        </div>
      </div>

      <div className="relative space-y-8 lg:pl-12">
        <div className="space-y-6">
          <h2 className="font-unbounded text-4xl lg:text-[48px] font-medium leading-tight lg:leading-[52px]">
            Share your story
          </h2>
          <p className="font-satoshi text-[22px] text-[#222222] leading-8">
            Whether you're looking to explore top college choices, understand admission trends, or find the best-fit schools based on where students from your high school have gone, SnapGrad has you covered.
          </p>
        </div>
        <a
          href="#reviews"
          className="inline-flex font-unbounded text-[17px] font-semibold text-black underline decoration-2 underline-offset-4 hover:text-brand-orange transition-colors"
        >
          Review your school
        </a>
      </div>
    </div>
  </section>
);

export const ProcessSection = () => (
  <section className="mx-auto px-4 sm:px-8 lg:px-[133px] py-16 lg:py-24">
    <div className="text-center space-y-6 mb-16">
      <h2 className="font-unbounded text-4xl lg:text-[48px] font-medium leading-tight lg:leading-[52px]">
        SnapGrad makes the process simple.
      </h2>
      <p className="font-satoshi text-[20px] text-[#2B2723] leading-8">
        With data-driven insights, SnapGrad helps you discover college opportunities.
      </p>
    </div>

    <div className="grid md:grid-cols-3 gap-10">
      {[
        {
          title: "Zero extra effort",
          description: "We crunch the numbers so you don't have to.",
          image: "https://api.builder.io/api/v1/image/assets/TEMP/88d861f535c136f3e81d670234baa3e89dbc1477?width=510",
          width: 255,
          height: 255,
          className: "",
        },
        {
          title: "The real picture",
          description: "Honest feedback - good, bad, and everything in between.",
          image: "https://api.builder.io/api/v1/image/assets/TEMP/e5e8c9416633ad33bea0ea775bf600f35192242d?width=436",
          width: 218,
          height: 178,
          className: "mt-12",
        },
        {
          title: "Tailored for you",
          description: "Insights filtered to match your unique priorities.",
          image: "https://api.builder.io/api/v1/image/assets/TEMP/f43891352bb6c34b6cc5a976a26eeb8c12c0e743?width=554",
          width: 277,
          height: 221,
          className: "mt-7",
        },
      ].map(({ title, description, image, width, height, className }) => (
        <div key={title} className="text-center space-y-5">
          <img
            src={image}
            alt={title}
            width={width}
            height={height}
            className={`mx-auto ${className}`.trim()}
          />
          <h3 className="font-unbounded text-[19px] font-semibold text-[#0F0F0F] tracking-[0.2em] uppercase">
            {title}
          </h3>
          <p className="font-satoshi text-[18px] text-[#555353] leading-7 max-w-[280px] mx-auto">
            {description}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export const DecisionSection = () => (
  <section className="py-16 lg:py-24">
    <div className="mx-auto px-4 sm:px-8 lg:px-[133px]">
      <div className="relative overflow-hidden rounded-[32px] border border-[#EEE5DF] shadow-[0px_35px_80px_rgba(16,16,16,0.16)]">
        <img
          /* REPLACED WITH PLACEHOLDER UNTIL LOCAL FILE PATH IS FIXED */
          src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1200&q=80"
          alt="Educators welcoming energetic students into school"
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
    </div>
  </section>
);

const LandingSchoolCard = ({
  name,
  rating,
  readiness,
  address,
  stars,
  reviews,
  type,
  level,
  className = "",
}) => (
  <div className={`relative z-10 bg-white rounded-[40px] p-6 border border-[#EEE5DF] shadow-[0px_30px_70px_rgba(15,15,15,0.16)] transition-all ${className}`}>
    <div className="flex items-start justify-between gap-4">
      <div className="space-y-4">
        <h3 className="font-unbounded text-[24px] leading-[30px] text-[#0F0F0F]">{name}</h3>
        <div className="flex flex-wrap gap-3">
          <TagPill label={type} />
          <TagPill label={level} />
        </div>
      </div>
      <button
        type="button"
        className="w-10 h-10 flex items-center justify-center hover:scale-110 transition-transform"
        aria-label="Add to favorites"
      >
        <Heart className="w-6 h-6 text-[#F76C2F]" strokeWidth={2.5} />
      </button>
    </div>

    <p className="mt-4 font-satoshi text-[16px] text-[#6F6862]">{address}</p>

    <div className="mt-6 space-y-3">
      <CondensedMetric label="SnapCollege Rating" value={rating} />
      <CondensedMetric label="College Readiness" value={readiness} />
    </div>

    <div className="mt-6 flex flex-wrap items-center gap-2 text-[16px]">
      <Star className="w-4 h-4 text-[#F4AA3C] fill-[#F4AA3C]" />
      <span className="font-semibold text-[#1C1A19]">{stars}</span>
      <span className="text-[#C9C2BD]" aria-hidden="true">&bull;</span>
      <span className="font-semibold text-[#F07639] underline decoration-2 underline-offset-4">
        {reviews} Reviews
      </span>
    </div>
  </div>
);

const TagPill = ({ label }) => (
  <span className="px-5 py-1.5 rounded-full border border-[#E8E0D7] bg-white font-satoshi text-[15px] font-medium text-[#3F3A37] shadow-[0px_10px_25px_rgba(15,10,5,0.08)]">
    {label}
  </span>
);

const MetricPill = ({ label, value }) => (
  <div className="flex items-center gap-4 rounded-[999px] border border-[#F5DCC8] bg-gradient-to-r from-white to-[#FFF6EE] px-4 py-4 shadow-[0px_20px_50px_rgba(24,16,8,0.12)] w-full">
    <div className="w-[60px] h-[60px] rounded-full bg-gradient-to-b from-[#FFB27F] to-[#F07639] flex items-center justify-center text-white font-unbounded text-[16px] border-4 border-white shadow-[0px_12px_30px_rgba(236,126,61,0.45)]">
      {value}
    </div>
    <span className="font-satoshi text-[18px] font-medium text-[#3C322B]">{label}</span>
  </div>
);

const CondensedMetric = ({ label, value }) => (
  <div className="flex items-center gap-3 rounded-[999px] border border-[#EFE4D9] bg-[#FBF7F3] px-3 py-2 w-full text-[15px] text-[#3F3731]">
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-b from-[#FFB27F] to-[#F07639] text-white font-unbounded text-xs">
      {value}
    </span>
    <span>{label}</span>
  </div>
);

const CompactSchoolCard = () => (
  <div className="relative bg-white border border-[#F1E6DB] rounded-[32px] p-5 shadow-[0px_30px_70px_rgba(24,16,8,0.15)]">
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="font-unbounded text-[20px] text-[#101010]">Texas City Independent High</p>
        <div className="mt-2 flex flex-wrap gap-2 text-[13px] text-[#4E463F]">
          <span className="px-3 py-0.5 rounded-full border border-[#E4D9CC] bg-[#FBF7F1]">Public</span>
          <span className="px-3 py-0.5 rounded-full border border-[#E4D9CC] bg-[#FBF7F1]">High School</span>
        </div>
      </div>
      <Heart className="w-6 h-6 text-[#F07639]" />
    </div>

    <div className="mt-4 text-[15px] text-[#4A4340]">Texas City Independent High, TX, 254</div>

    <div className="mt-4 flex flex-wrap gap-3">
      <MiniMetric label="SnapCollege Rating" value="6/10" />
      <MiniMetric label="College Readiness" value="10" />
    </div>

    <div className="mt-4 flex items-center gap-2 text-[14px] text-[#3F3935]">
      <Star className="w-4 h-4 text-[#F4AA3C] fill-[#F4AA3C]" />
      <span className="font-semibold">4.9</span>
      <span className="text-[#D1CAC4]">&bull;</span>
      <a className="font-semibold text-[#F07639] underline decoration-2 underline-offset-4" href="#reviews">
        300 Reviews
      </a>
    </div>
  </div>
);

const MiniMetric = ({ label, value }) => (
  <div className="flex items-center gap-2 rounded-[20px] border border-[#F1E0CE] bg-[#FFF8F2] px-3 py-2 text-[13px] text-[#3F3832]">
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-b from-[#FFB27F] to-[#F07639] text-white font-unbounded text-xs">
      {value}
    </span>
    <span>{label}</span>
  </div>
);

export default {
  HeroSection,
  CompareSection,
  HomeSearchSection,
  ShareStorySection,
  ProcessSection,
  DecisionSection,
};
